// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__11HK1","row":"Node_row__35MCs","label":"Node_label__1aLCi","footer":"Node_footer__pZxEr"};